
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ModeProvider } from './context/modeContext';
import ModeGate from "./modeGate";
import './App.css';
import ProtectedRoute from './Component/guards/ProtectedRoute';
import FirstScreen from './Pages/Firstscreen';
import Secondscreen from './Pages/Secondscreen';
import Disclaimer from './Pages/Disclaimer';
import Chatbot from './Pages/Chatbot';
import Result from './Pages/Result';
import Admin from './Pages/Admin';
import User from './Pages/User';
import Sidebar from './Pages/Sidebar';
import { LanguageProvider } from './context/LanguageContext';
import Aboutpage from './Pages/Aboutpage';
import Contactpage from './Pages/Contactpage';
import Privacypage from './Pages/Privacypage';
import Termspage from './Pages/Termspage';
import Awarenesspage from './Pages/Awarenesspage';
import Loginpage from './Pages/Loginpage';
import Doctorpage from './Pages/Doctorpage';
import Paitentsform from './Pages/Paitentsform';
import Landingpage from './Pages/Landingpage';
import Register from './Pages/Register';

function App() {

  return (
    <LanguageProvider>
      <ModeProvider>
      <BrowserRouter>
        <Routes>
        <Route path="/public" element={<ModeGate mode="public" />} />
        <Route path="/private" element={<ModeGate mode="private" />} />
          <Route path='/' element={<FirstScreen />}></Route>
          <Route path='/secondscreen' element={<Secondscreen />} />
          <Route path='/disclaimer' element={<Disclaimer />} />   
           <Route path='/Paitentsform' element={<Paitentsform />} />                                    
          <Route path='/chatbot' element={<Chatbot />} />
          <Route path='/result' element={<Result />} />
          <Route path='/register/staff' element={<Register />} />
          <Route
              path="/admin"
              element={
                <ProtectedRoute roleRequired="admin">
                  <Admin />
                </ProtectedRoute>
              }
            />

            <Route
              path="/doctor"
              element={
                <ProtectedRoute roleRequired="doctor">
                  <Doctorpage />
                </ProtectedRoute>
              }
           />

          <Route path='/login' element={<Loginpage />} />  
          <Route path='/user/:id' element={<User />} />
          <Route path='/more' element={< Sidebar />} />
          <Route path='/about' element={< Aboutpage />} />
          <Route path='/contact' element={< Contactpage />} /> 

          <Route path='/privacy' element={< Privacypage />} />
          <Route path='/terms' element={< Termspage />} />
          <Route path='/awareness' element={<Awarenesspage />} />
          <Route path="*" element={<div>Page Not Found</div>} />

        </Routes>
      </BrowserRouter>
      </ModeProvider>
    </LanguageProvider>
  );
}

export default App;
